exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".loader-wrap[data-v-05e1af30]{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%)}.loader[data-v-05e1af30]{border-radius:50%;border:2px solid #f3f3f3;border-top-color:#3498db;width:40px;height:40px;-webkit-animation:spin-data-v-05e1af30 2s linear infinite;animation:spin-data-v-05e1af30 2s linear infinite}@-webkit-keyframes spin-data-v-05e1af30{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}@keyframes spin-data-v-05e1af30{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}", ""]);

// exports
